import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cv-stub',
  standalone: true,
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StubComponent {}
